// extracted by mini-css-extract-plugin
export default {"blogCard":"Blog_blogCard__oxoPj","blogCategory":"Blog_blogCategory__NAtE2","blogTitle":"Blog_blogTitle__a9DYZ","blogReadMore":"Blog_blogReadMore__+ufFw"};